// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__ifoi_","inner":"Footer_inner__3KOgA"};